import { map, isEmpty } from 'underscore';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Button, makeStyles } from '@fluentui/react-components';
import { UiBlocker } from '@bingads-webui-react/ui-blocker';

const useStyles = makeStyles({
  socialRecommendationContainer: {
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'column',
    '& .title': {
      fontWeight: '600',
    },
    '& .url-container': {
      display: 'flex',
      flexDirection: 'column',
      paddingTop: '10px',
      paddingBottom: '10px',
    },
    '& .generate-button': {
      width: '140px',
      marginLeft: 'auto',
    },
  },
});

export const SocialSiteRecommendationSection = ({
  i18n, isSocialSitesLoading, socialSites, onSocialSiteCheckboxChange, prefillAssetRecommendation,
}) => {
  const classes = useStyles();

  const onCheckboxChange = useCallback((index, checked) => {
    onSocialSiteCheckboxChange(index, checked);
  }, [onSocialSiteCheckboxChange]);

  const onGenerateButtonClick = useCallback(() => {
    prefillAssetRecommendation();
  }, [prefillAssetRecommendation]);

  return (
    <UiBlocker blocking={isSocialSitesLoading} loadingText={i18n.getString(_TL_('Loading'))}>
      <div className={classes.socialRecommendationContainer}>
        <div className="title">{i18n.getString(_TL_('Select pages to enhance recommendations'))}</div>
        {isSocialSitesLoading ? <div style={{ height: 100 }} /> : (
          <div className="url-container">
            {
              map(socialSites, (recommendation, index) => (
                <Checkbox
                  key={index}
                  size="large"
                  label={recommendation.Url}
                  checked={recommendation.checked}
                  onChange={(_evt, data) => onCheckboxChange(index, data.checked)}
                />
              ))
            }
          </div>
        )}
        {!isEmpty(socialSites) && (
          <Button
            primary
            className="generate-button"
            onClick={onGenerateButtonClick}
          >
            {i18n.getString(_TL_('Generate assets'))}
          </Button>
        )}
      </div>
    </UiBlocker>
  );
};

SocialSiteRecommendationSection.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  isSocialSitesLoading: PropTypes.bool.isRequired,
  socialSites: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSocialSiteCheckboxChange: PropTypes.func.isRequired,
  prefillAssetRecommendation: PropTypes.func.isRequired,
};

